import React from 'react';
import { Typography } from '@mui/material';
function ConfigOptionFeedback() {
  return (
    <Typography
      id="econfig-filterFeedback-csat"
      className="ph-survey-link"
      // sx={{
      //   color: '#0076cc !important',
      //   cursor: 'pointer',
      //   marginLeft: '6px',
      //   fontSize: '16px',
      //   fontWeight: '500',
      //   display: 'inline',
      //   lineHeight: 1,
      //   paddingBottom: '10px',
      //   '&:hover': {
      //     textDecoration: 'underline'
      //   }
      // }}
    ></Typography>
  );
}

export default ConfigOptionFeedback;
